export const meta: BlockMeta = {
  title: "Themed Columns",
  tags: ["subpage"],
  flags: {
    fullWidth: true,
  },
}

import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/themed-columns", (props) => {
  return (
    <div className={cn("w-full my-10 md:px-4", !env.admin && "grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4")}>
      <InnerBlocks
        allowedBlocks={["content/themed-columns-item"]}
        orientation="horizontal"
        adminClassName="w-full grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-4 [&_.wp-block]:w-full"
        template={[
          ["content/themed-columns-item", {}],
          ["content/themed-columns-item", {}],
          ["content/themed-columns-item", {}],
        ]}
      />
    </div>
  )
})
